export default () => ({
  newsPaginationPage: null,
  newsPaginationPagesTotal: null,
  news: [],
  tags: [],
  activeTag: null,
  newsArticle: {},
})
